import React, { useState } from 'react';
import axios from 'axios';
import API from '../../API';
import ProjectCard from '../../newComponents/projectSummery/projectCard';
import BidCard from '../../newComponents/projectSuccessfull/bidCard';
import QuestionAnswer from "../../newComponents/projectSummery/questionAnswerCard";
import ProviderCard from "../../newComponents/projectSummery/providerCard";
import ProviderReview from '../../newComponents/projectSummery/providerReview';
import { Card, Typography, Button, Popover } from 'antd';
import { EditOutlined, DeleteOutlined, EnvironmentOutlined } from '@ant-design/icons';
import './projectSummary.css';
import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import { useParams } from 'react-router-dom';
const ProjectSummary = ({
    status,
    question_answers,
    description,
    project_all_images_url,
    project_all_videos_url,
    roof_scope,
    pdf,
    consumer_avatar_url,
    project_sub_type_image,
    video_count,
    image_count,
    project_type,
    project_id,
    unique_project_id,
    project_img_url,
    provider_name,
    provider_id,
    provider_ratings,
    provider_mobile,
    provider_avatar,
    rating_all_together,
    is_pro_user,
    is_insurance_verified,
    insured,
    address,
    provider_project_id,
    years_of_experience,
    amount_payable_to_provider,
    bid_detail_pdf,
    bid_type,
    bid_amount,
    hours,
    total_amount,
    discount_amount,
    bid_detail_text,
    title,
    is_reviewed, }) => {

    const [popoverVisible, setPopoverVisible] = useState(false);
    const { id } = useParams();
    const deleteProject = () => {
        const data = {
            id: project_id,
            is_soft_delete: false
        }
        axios.put(API.baseURL + `/v2/customers/projects/${id}/soft_delete`,
            data,
            API.options
        ).then((res) => {
            window.location.href = "/my-projects"
        })
    }

    const handleEditClick = () => {
        window.location.href = `/edit-project/${id}`;
    };

    return (
        <div className="project-summary-container">
            <Card className="project-main-card">
                <div className="project-image-section" style={{ position: 'relative' }}>
                    <Swiper
                        // modules={[Navigation, Pagination]}
                        navigation={{
                            prevEl: '.prev3',
                            nextEl: '.next3',
                        }}
                        // pagination={{ clickable: true }}
                        className="ebw-swiper__container"
                        style={{ width: '100%', height: '400px' }}
                    >
                        {(!project_all_images_url && !project_all_videos_url) || 
                         (project_all_images_url?.length === 0 && project_all_videos_url?.length === 0) ? (
                            <SwiperSlide>
                                <img 
                                    src={project_img_url || project_sub_type_image} 
                                    alt={title}
                                    style={{ width: '100%', height: '400px', objectFit: 'contain' }}
                                />
                            </SwiperSlide>
                        ) : (
                            <>
                                {project_all_images_url?.map((image, index) => (
                                    <SwiperSlide key={`image-${index}`}>
                                        <img 
                                            src={image} 
                                            alt={`${title} - ${index + 1}`}
                                            style={{ width: '100%', height: '400px', objectFit: 'contain' }}
                                        />
                                    </SwiperSlide>
                                ))}
                                {project_all_videos_url?.map((video, index) => (
                                    <SwiperSlide key={`video-${index}`}>
                                        <video
                                            controls
                                            style={{ width: '100%', height: '400px', objectFit: 'contain' }}
                                        >
                                            <source src={video.replace('thumb_', '')} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </SwiperSlide>
                                ))}
                            </>
                        )}
                    </Swiper>
                    <div style={{ position: 'absolute', right: 10, top: 10, zIndex: 1 }}>
                        <span style={{ background: '#000000aa', color: 'white', padding: '4px 8px', borderRadius: '4px' }}>
                            {image_count} Photo • {video_count} Video
                        </span>
                    </div>
                    <div className="ebw-slider__navigation">
                        <div className="ebw-slider__navigation-arrow  prev3">
                            <i className="ebw-icon ebw-icon--xl icon-arrow-left ebw-slider__navigation-arrow--icon "></i>
                        </div>
                        <div className="ebw-slider__navigation-arrow next3 ebw-slider__navigation-arrow--active">
                            <i className="ebw-icon ebw-icon--xl icon-arrow-right ebw-slider__navigation-arrow--icon"></i>
                        </div>
                    </div>
                </div>

                <div style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <Typography.Title level={4}>{title}</Typography.Title>
                        <Typography.Text type="secondary">{project_type}</Typography.Text>
                    </div>
                    <div>
                        <Button 
                            icon={<EditOutlined />} 
                            onClick={handleEditClick}
                            style={{ marginRight: 8 }}
                        />
                        <Popover
                            content={
                                <div>
                                    <p>Are you sure you want to delete this project?</p>
                                    <Button danger onClick={deleteProject}>Delete</Button>
                                </div>
                            }
                            title="Delete Project"
                            trigger="click"
                            visible={popoverVisible}
                            onVisibleChange={setPopoverVisible}
                        >
                            <Button icon={<DeleteOutlined />} danger />
                        </Popover>
                    </div>
                </div>

                <Card className="project-details-card" style={{ margin: '16px' }}>
                    <div style={{ marginBottom: 16 }}>
                        <Typography.Text strong>Project ID: </Typography.Text>
                        <Typography.Text copyable style={{fontSize: 16}}>{unique_project_id}</Typography.Text>
                    </div>
                    
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                        <EnvironmentOutlined style={{ marginRight: 8 }} />
                        <Typography.Text>{address?.city}, {address?.state} ({address?.zip_code})</Typography.Text>
                    </div>

                    <div>
                        <Typography.Title level={5}>Project Description</Typography.Title>
                        <Typography.Paragraph>{description}</Typography.Paragraph>
                    </div>
                </Card>
            </Card>

            {status === 3 &&
                <ProviderCard
                    bid_amount={bid_amount}
                    project_id={project_id}
                    provider_name={provider_name}
                    provider_ratings={provider_ratings}
                    provider_mobile={provider_mobile}
                    rating_all_together={rating_all_together}
                    is_pro_user={is_pro_user}
                    is_insurance_verified={is_insurance_verified}
                    insured={insured}
                    provider_id={provider_id}
                    provider_avatar={provider_avatar}
                    provider_project_id={provider_project_id}
                    title={title}
                    years_of_experience={years_of_experience}
                />
            }

            {status === 4 &&
                <ProviderReview
                    provider_name={provider_name}
                    provider_ratings={provider_ratings}
                    provider_mobile={provider_mobile}
                    rating_all_together={rating_all_together}
                    is_pro_user={is_pro_user}
                    is_insurance_verified={is_insurance_verified}
                    project_id={project_id}
                    insured={insured}
                    provider_id={provider_id}
                    provider_avatar={provider_avatar}
                    provider_project_id={provider_project_id}
                    years_of_experience={years_of_experience}
                    is_reviewed={is_reviewed}
                />
            }

            {status === 6 || status === 9 &&
                <ProviderReview
                    provider_name={provider_name}
                    provider_ratings={provider_ratings}
                    provider_mobile={provider_mobile}
                    rating_all_together={rating_all_together}
                    is_pro_user={is_pro_user}
                    is_insurance_verified={is_insurance_verified}
                    project_id={project_id}
                    insured={insured}
                    provider_id={provider_id}
                    provider_avatar={provider_avatar}
                    provider_project_id={provider_project_id}
                    years_of_experience={years_of_experience}
                    is_reviewed={true}
                />
            }

            {((status === 3 || status === 4 || status === 6 || status === 9)) &&
                <>
                    <BidCard
                        amount_payable_to_provider={amount_payable_to_provider}
                        bid_type={bid_type}
                        bid_amount={bid_amount}
                        hours={hours}
                        total_amount={total_amount}
                        discount_amount={discount_amount}
                        bid_detail_pdf={bid_detail_pdf}
                        bid_detail_text={bid_detail_text}
                    />
                </>
            }

            <QuestionAnswer
                question_answers={question_answers}
                description={description}
                roof_scope={roof_scope}
                pdf={pdf}
            />
        </div>
    );
}

export default ProjectSummary;